import React from "react";

import { Button as RSButton } from "reactstrap";

const styles = {
	minWidth: "125px",
	height: "40px"
};

const Button = (props) => {
	const { children, color, disabled, onClick, type } = props;

	return (
		<RSButton
			type={type}
			disabled={disabled}
			color={color}
			onClick={onClick}
			style={styles}
		>
			{children}
		</RSButton>
	);
};

export default Button;
